( ( $ ) => {

	const blockRootSelector = '.testimonials';
	const blockName = 'blockTestimonials';

	/// All logic and initialization is inside this function.
	function initializeBlock( el ) {

		const $slickEl = $( '[data-testimonials-slider]', el );

		$slickEl.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 4,
					}
				}
			]
		} );

		// return  element so later it'll not be reinitialized
		return el;
	}


	//we initialize blocks of this type which are already rendered on page not via ajax.
	$( blockRootSelector ).each( ( index, el ) => {

		const blockId = `wpshopify_initial_${ blockName }_${ index }`;

		window.WPShopify.blockInstances[blockId] = {
			el: el,
			id: blockId,
			blockInitFunctionName: blockName,
			instance: initializeBlock( el )
		};

	} );

	// save our block initializer function to storage to make it possible to init blocks of same type loaded by ajax.
	window.WPShopify.blocksInits[blockName] = initializeBlock;


} )( jQuery );
